import { isClinic } from './client';
export var isShowFormattedPhone = function isShowFormattedPhone(can) {
  var isShowFormattedPhoneAtClinic = can({
    type: 'data',
    subject: 'branch_visit',
    action: 'read',
    property: 'formattedPhone'
  });
  return isClinic() ? isShowFormattedPhoneAtClinic : false;
};
export var isShowOriginalPhone = function isShowOriginalPhone(can) {
  // Original phone: have country code
  var isShowPhoneAtClinic = can({
    type: 'data',
    subject: 'branch_visit',
    action: 'read',
    property: 'phone'
  });
  return isClinic() ? isShowPhoneAtClinic : true;
};